export function validateEmailAddress(email: string): string | null {
  const trimmedEmail = email.trim();
  if (!trimmedEmail) return 'Email is required.';
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmedEmail)) return 'Enter a valid email address.';
  return null;
}

export function validateLoginForm(email: string, password: string): string | null {
  const emailError = validateEmailAddress(email);
  if (emailError) return emailError;
  if (!password) return 'Password is required.';
  return null;
}

export function validateSignUpForm(email: string, password: string, confirmPassword: string): string | null {
  const trimmedEmail = email.trim();
  const emailError = validateEmailAddress(trimmedEmail);
  if (emailError) return emailError;
  if (password.length < 8) return 'Password must be at least 8 characters.';
  if (!confirmPassword) return 'Please confirm your password.';
  if (password !== confirmPassword) return 'Passwords do not match.';
  return null;
}

export function validatePasswordReset(password: string, confirmPassword: string): string | null {
  if (password.length < 8) return 'Password must be at least 8 characters.';
  if (!confirmPassword) return 'Please confirm your password.';
  if (password !== confirmPassword) return 'Passwords do not match.';
  return null;
}
